import { render, staticRenderFns } from "./QuinesSomos.vue?vue&type=template&id=eb08f814"
import script from "./QuinesSomos.vue?vue&type=script&lang=js"
export * from "./QuinesSomos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports